




























































































/* eslint-disable */
import { Component, Emit, Prop, Watch, Vue } from 'vue-property-decorator'
import Provisao from '@/store/Provisao'
import IsProcedimentoMaiorPorte from '@/factories/IsProcedimentoMaiorPorte'

@Component

export default class ComponentCalculadoraProcedimento extends Vue {
  @Prop() index
  @Prop(Object) procedimento
  @Prop(Array) procedimentos

  get isProcedimentoMaiorPorte(): Boolean {
    return IsProcedimentoMaiorPorte(this.procedimentos, this.procedimento, this.index)
  }

  getSequencial(newValue) {
    this.procedimento.sequencial = newValue
    return this.procedimento.sequencial
  }

  async getCalculoProvisao() {
    this.procedimento.sequencial = this.index + 1

    Provisao.dispatch('CALCULADORA_PROVISAO')
    Provisao.dispatch('HABILITAR_ENVIO_PROVISAO')
  }

  async removeProcedimento(index) {
    Provisao.dispatch('REMOVE_PROCEDIMENTO_SELECTED', index)
    Provisao.dispatch('HABILITAR_ENVIO_PROVISAO')

    Provisao.dispatch('RESET_CALCULADORA')

    if (this.getProcedimentos.length > 0) {
      Provisao.dispatch('SET_BLOQUEAR_INFORMACOES_ADICIONAIS', false)
      Provisao.dispatch('CALCULADORA_PROVISAO')
      this.clearFuncaorofissionalExecutante()
    } else {
      Provisao.dispatch('SET_INFORMACOES_ADICIONAIS_STATUS_COLOR', 'secondary')
      Provisao.dispatch('SET_FUNCOES_STATUS_COLOR', 'secondary')
      Provisao.dispatch('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', true)
      Provisao.dispatch('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', true)
      Provisao.dispatch('SET_BLOQUEAR_INFORMACOES_ADICIONAIS', true)
      Provisao.dispatch('RESET_INFORMACOES_ADICIONAIS')
      Provisao.dispatch('RESET_FUNCAO')
    }
  }

  getDescricaoAuxiliares() {
    return `${this.procedimento.quantidadeAuxiliarPermitido} Auxiliares`
  }

  get getProcedimentos() {
    return Provisao.getters.PROCEDIMENTOS
  }

  setSequencialInit() {
    this.procedimento.sequencial = this.index + 1
  }

  setQuantidadeInit() {
    if (this.index === 0)
      this.procedimento.quantidade = this.index + 1
  }

  setViaAcessoInit() {
    if (this.index === 0)
      this.procedimento.viaAcesso = this.index + 1
  }

  get getProfissionalExecutanteSelecionado() {
    return Provisao.getters.PROFISSIONAIS_EXECUTANTES
  }

  get getFuncao() {
    return Provisao.getters.FUNCAO
  }

  clearFuncaorofissionalExecutante() {

    this.getProfissionalExecutanteSelecionado.map(p => {
      if ( p.status === false) {
        switch(p.funcao) {
          case 1:
              const auxiliar1 = this.getProcedimentos.filter(p => p.quantidadeAuxiliarPermitido > 0)
              if (auxiliar1.length === 0) {
                p.funcao = ''
                p.status = true
                this.getFuncao.auxiliares.auxiliar1 = ''
              }
            break
          case 2:
              const auxiliar2 = this.getProcedimentos.filter(p => p.quantidadeAuxiliarPermitido > 1)
              if (auxiliar2.length === 0) {
                p.funcao = ''
                p.status = true
                this.getFuncao.auxiliares.auxiliar2 = ''
              }
            break
          case 3:
              const auxiliar3 = this.getProcedimentos.filter(p => p.quantidadeAuxiliarPermitido > 2)
              if (auxiliar3.length === 0) {
                p.funcao = ''
                p.status = true
                this.getFuncao.auxiliares.auxiliar3 = ''
              }
            break
          case 4:
              const auxiliar4 = this.getProcedimentos.filter(p => p.quantidadeAuxiliarPermitido > 3)
              if (auxiliar4.length === 0) {
                p.funcao = ''
                p.status = true
                this.getFuncao.auxiliares.auxiliar4 = ''
              }
            break
          case 5:
              const instrumentador = this.getProcedimentos.filter(p => p.aplicaInstrumentador)
              if (instrumentador.length === 0) {
                p.funcao = ''
                p.status = true
                this.getFuncao.instrumentador = ''
              }
            break
          case 6:
              const anestesico = this.getProcedimentos.filter(p => p.aplicaAnestesico)
              if (anestesico.length === 0) {
                p.funcao = ''
                p.status = true
                this.getFuncao.anestesista = ''
              }
            break
          default:
            break
        }
      }
    });
  }

  mounted() {
    this.setSequencialInit()
    this.setQuantidadeInit()
    this.setViaAcessoInit()
  }
}
